module.exports = __webpack_public_path__ + "img/kenan-logo.622a471c.png";